<template>
  <Headers> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <p :class="[deviceType, 'cardName']">{{ prop.cardName }}</p>
    <PogressBarStep
      :cardName="prop.cardName"
      :currentStep="1"
      :countDown="prop.countDown"
    >
    </PogressBarStep>

    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div :class="[deviceType, 'inner']">
        <div :class="[deviceType, 'content']">
          <div :class="[deviceType, 'separator']">
            <div :class="[deviceType]">
              <div :class="[deviceType, 'inputText']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.basicInformation.name"
                  :value="prop.basicInformation.name"
                  field="fullName"
                  :required="false"
                  :placeholder="t('ccOnBoarding.basicInformation.fullName')"
                  :max-length="100"
                  :autocomplete="'new-password'"
                  @keydown="handleNameKeyDown"
                  :disabled="
                    (prop.basicInformation.idType == '0' &&
                      prop.ekyc == 'COMPLETE') ||
                    bioDisabledField ||
                    finPlusAndMosDisabledField
                  "
                />
              </div>
            </div>
            <div :class="[deviceType, 'container2']">
              <div :class="[deviceType, 'flex_dropdown']">
                <DropDown
                  v-model="prop.basicInformation.idType"
                  :selectedOption="prop.basicInformation.idType"
                  :options="idTypeList"
                  :value="idTypeList"
                  field="idType"
                  :placeholder="t('ccOnBoarding.basicInformation.idType')"
                  :disabled="
                    (prop.basicInformation.idType == '0' &&
                      prop.ekyc == 'COMPLETE') ||
                    finPlusAndMosDisabledField
                  "
                />
              </div>
              <div :class="[deviceType, 'flex_inputText']">
                <InputText
                  ref="idNoInput"
                  class="inputcomponent"
                  v-model="prop.basicInformation.idNo"
                  :value="prop.basicInformation.idNo"
                  :field="'idNo'"
                  :required="false"
                  :placeholder="
                    prop.basicInformation.idType == '1'
                      ? t('ccOnBoarding.basicInformation.passportNumber')
                      : prop.basicInformation.idType != '1' &&
                          prop.basicInformation.idType != ''
                        ? t('ccOnBoarding.basicInformation.ic')
                        : t('ccOnBoarding.basicInformation.icPassportNumber')
                          ? t('ccOnBoarding.basicInformation.icPassportNumber')
                          : t('ccOnBoarding.basicInformation.icPassportNumber')
                  "
                  :max-length="computedMaxLength"
                  :autocomplete="'new-password'"
                  :pattern="computedPattern"
                  :number="
                    prop.basicInformation.idType === '0' ||
                    prop.basicInformation.idType === '2' ||
                    prop.basicInformation.idType === '3'
                      ? 'true'
                      : 'false'
                  "
                  @keydown="handleKeyDown"
                  :disabled="
                    (prop.basicInformation.idType == '0' &&
                      prop.ekyc == 'COMPLETE') ||
                    bioDisabledField ||
                    ((prop.basicInformation.idType == '0' ||
                      prop.basicInformation.idType == '2' ||
                      prop.basicInformation.idType == '3') &&
                      prop.autoPopulateDisabledField.icNo) ||
                    (prop.basicInformation.idType == '1' &&
                      prop.autoPopulateDisabledField.passport) ||
                    finPlusAndMosDisabledField
                  "
                  :clear="
                    prop.type == 'BIO' && prop.webFormRequestId
                      ? 'false'
                      : isClear
                  "
                  :idType="
                    prop.isAutoPopulate ? '' : prop.basicInformation.idType
                  "
                  :type="'text'"
                  :inputmode="
                    prop.basicInformation.idType != '1' ? 'numeric' : 'text'
                  "
                />
              </div>
            </div>
            <div class="full" style="margin-bottom: 14px">
              <InputText
                v-if="
                  prop.basicInformation.idType == '2' ||
                  prop.basicInformation.idType == '3'
                "
                class="inputcomponent"
                v-model="prop.basicInformation.militaryNo"
                field="militaryNo"
                :required="false"
                :placeholder="
                  prop.basicInformation.idType == '2'
                    ? t('ccOnBoarding.basicInformation.myTentera')
                    : prop.basicInformation.idType == '3'
                      ? t('ccOnBoarding.basicInformation.myPolis')
                      : t('ccOnBoarding.basicInformation.militaryNumber')
                "
                :max-length="21"
                :autocomplete="'new-password'"
                :disabled="prop.autoPopulateDisabledField.militaryNo"
              />
            </div>

            <div
              v-if="
                (prop.basicInformation.idType == '0' ||
                  prop.basicInformation.idType == '2' ||
                  prop.basicInformation.idType == '3') &&
                computedDobTwo <= '78' &&
                Number(computedDobTwo) >= currentYear &&
                computedDobTwo != ''
              "
              class="full"
              style="margin-bottom: 14px"
            >
              <InputText
                class="inputcomponent"
                v-model="prop.basicInformation.oldIc"
                field="oldIc"
                :required="false"
                :placeholder="t('ccOnBoarding.basicInformation.oldIc')"
                :min-length="8"
                :max-length="8"
                :autocomplete="'new-password'"
              />
            </div>
            <div :class="[deviceType, 'container2']">
              <div :class="[deviceType, 'flex_half']">
                <DropDown
                  v-model="prop.basicInformation.nationality"
                  :selectedOption="prop.basicInformation.nationality"
                  :options="nationalityList"
                  :value="nationalityList"
                  :default="true"
                  :default-value="defaultNationality"
                  field="nationality"
                  :placeholder="t('ccOnBoarding.basicInformation.nationality')"
                  :disabled="
                    (prop.basicInformation.idType == '0' && prop.ekyc != '') ||
                    prop.basicInformation.idType === '0' ||
                    prop.basicInformation.idType === '2' ||
                    prop.basicInformation.idType === '3' ||
                    prop.autoPopulateDisabledField.nationality
                  "
                />
              </div>

              <div :class="[deviceType, 'flex_half']">
                <DatePicker
                  :class="[deviceType, 'dates']"
                  :disabled="
                    (prop.basicInformation.idType == '0' && prop.ekyc != '') ||
                    prop.basicInformation.idType != '1'
                  "
                  field="dob"
                  v-model:date-selected="prop.basicInformation.dob"
                  :placeholder="t('ccOnBoarding.basicInformation.dob')"
                  :defaultValue="
                    prop.basicInformation.idType != '1'
                      ? computedDob
                      : year + month + day
                  "
                  :autocomplete="'new-password'"
                />
                <!-- v-dateFormat -->
              </div>
            </div>
            <div
              v-if="prop.selectedCard.cardId == 'JC' || prop.cardId == 'JC'"
              :class="[deviceType]"
            >
              <div :class="[deviceType, 'inputText']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.basicInformation.jcklMembershipNo"
                  :value="prop.basicInformation.jcklMembershipNo"
                  field="jcklMembershipNo"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.basicInformation.jcklMembershipNo')
                  "
                  :max-length="50"
                  :autocomplete="'new-password'"
                  @keydown="handleJCKLMembershipKeyDown"
                />
              </div>
            </div>

            <div
              v-if="prop.selectedCard.cardId == 'JC' || prop.cardId == 'JC'"
              class="dropdown"
            >
              <DropDown
                v-model="prop.basicInformation.jcklClubStatus"
                :selectedOption="prop.basicInformation.jcklClubStatus"
                :options="jcklClubStatusList"
                :value="jcklClubStatusList"
                field="jcklClubStatus"
                :placeholder="t('ccOnBoarding.basicInformation.jcklClubStatus')"
              />
            </div>
          </div>
          <div :class="[deviceType, 'separator']">
            <div :class="[deviceType, 'inputText']">
              <InputText
                class="inputcomponent"
                v-model="prop.basicInformation.email"
                field="email"
                :required="false"
                :placeholder="t('ccOnBoarding.basicInformation.email')"
                :max-length="100"
                :autocomplete="'new-password'"
                :disabled="
                  prop.status === 'false' ||
                  prop.otp.otpMobile.status === 'falseOtp' ||
                  prop.otp.otpEmail.validated ||
                  prop.isAutoPopulate ||
                  finPlusAndMosDisabledField
                "
                :noCapital="true"
              />
            </div>

            <div
              :class="[deviceType, 'container3']"
              style="margin-bottom: 14px"
            >
              <div :class="[deviceType, 'flex_third']">
                <DropDown
                  v-model="prop.basicInformation.countryCode"
                  :selectedOption="prop.basicInformation.countryCode"
                  :options="mobileCountryCodeList.slice(0, 2)"
                  :value="mobileCountryCodeList.slice(0, 2)"
                  :default="true"
                  :default-value="'60'"
                  field="countryCode"
                  :placeholder="
                    deviceType != 'Mobile'
                      ? t('ccOnBoarding.basicInformation.countryCode')
                      : ''
                  "
                  :disabled="
                    prop.status === 'false' ||
                    prop.otp.otpEmail.status === 'falseEmail' ||
                    prop.otp.otpMobile.validated ||
                    prop.isAutoPopulate ||
                    finPlusAndMosDisabledField
                  "
                  :is-country-code="true"
                />
              </div>
              <div :class="[deviceType, 'flex_inputText']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.basicInformation.mobileNo"
                  field="mobileNo"
                  :required="false"
                  :placeholder="t('ccOnBoarding.basicInformation.mobileNo')"
                  :max-length="
                    prop.basicInformation.countryCode == '65' ? 9 : 10
                  "
                  :min-length="
                    prop.basicInformation.countryCode == '65' ? 8 : 9
                  "
                  :autocomplete="'new-password'"
                  onkeypress="
                    return event.charCode >= 48 && event.charCode <= 57;
                  "
                  :number="'true'"
                  :type="'text'"
                  :pattern="'[0-9]*'"
                  :inputmode="'numeric'"
                  :trim="true"
                  :disabled="
                    prop.status === 'false' ||
                    prop.otp.otpEmail.status === 'falseEmail' ||
                    prop.otp.otpMobile.validated ||
                    prop.isAutoPopulate ||
                    finPlusAndMosDisabledField
                  "
                />
              </div>
            </div>
            <div
              :class="[deviceType, 'container3']"
              style="margin-bottom: 14px"
            >
              <div :class="[deviceType, 'flex_third']">
                <DropDown
                  v-model="prop.basicInformation.homeCountryCode"
                  :selectedOption="prop.basicInformation.homeCountryCode"
                  :options="mobileCountryCodeList.slice(0, 2)"
                  :value="mobileCountryCodeList.slice(0, 2)"
                  :default="true"
                  :default-value="'60'"
                  field="homeCountryCode"
                  :placeholder="
                    deviceType != 'Mobile'
                      ? t('ccOnBoarding.basicInformation.countryCode')
                      : ''
                  "
                  :is-country-code="true"
                />
              </div>
              <div :class="[deviceType, 'flex_inputText']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.basicInformation.homePhoneNo"
                  field="homeNo"
                  :required="false"
                  :placeholder="t('ccOnBoarding.basicInformation.homeNo')"
                  :max-length="10"
                  :min-length="7"
                  :autocomplete="'new-password'"
                  onkeypress="
                    return event.charCode >= 48 && event.charCode <= 57;
                  "
                  :number="'true'"
                  :type="'text'"
                  :pattern="'[0-9]*'"
                  :inputmode="'numeric'"
                  :trim="true"
                />
              </div>
            </div>
          </div>

          <div class="full">
            <div class="disclaimerContainer1">
              <div class="disclaimerSubContainer1">
                {{
                  t(
                    "ccOnBoarding.basicInformation.grossMonthlySalaryDisclaimer",
                  )
                }}
              </div>
            </div>
            <div :class="[deviceType, 'container4']">
              <div :class="[deviceType, 'inputText']">
                <NewCurrencyInput
                  class="inputcomponent"
                  v-model.number="prop.basicInformation.grossSalary"
                  field="grossSalary"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.basicInformation.grossMonthlySalary')
                  "
                  :max-length="15"
                  :autocomplete="'new-password'"
                  :inputmode="'numeric'"
                  onkeypress="
                    return event.charCode >= 48 && event.charCode <= 57;
                  "
                />
              </div>
              <div :class="[deviceType, 'inputText']">
                <NewCurrencyInput
                  class="inputcomponent"
                  v-model.number="prop.basicInformation.netSalary"
                  field="netSalary"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.basicInformation.netMonthlySalary')
                  "
                  :max-length="15"
                  :autocomplete="'new-password'"
                  :inputmode="'numeric'"
                  onkeypress="
                    return event.charCode >= 48 && event.charCode <= 57;
                  "
                />
              </div>
            </div>
            <div
              v-if="prop.basicInformation.profession != '90'"
              class="dropdown"
            >
              <DropDown
                v-model="prop.basicInformation.profession"
                :selectedOption="prop.basicInformation.profession"
                :options="professionList"
                :value="professionList"
                field="profession"
                :placeholder="t('ccOnBoarding.basicInformation.profession')"
              />
            </div>
            <div v-else-if="prop.basicInformation.profession == '90'">
              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'flex_half']">
                  <DropDown
                    v-model="prop.basicInformation.profession"
                    :selectedOption="prop.basicInformation.profession"
                    :options="professionList"
                    :value="professionList"
                    field="profession"
                    :placeholder="t('ccOnBoarding.basicInformation.profession')"
                  />
                </div>
                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    v-if="prop.basicInformation.profession == '90'"
                    class="inputcomponent"
                    v-model="prop.basicInformation.others"
                    field="others"
                    :required="false"
                    :placeholder="t('ccOnBoarding.basicInformation.others')"
                    :max-length="20"
                    :autocomplete="'new-password'"
                    @keydown.enter.prevent="handleEnterKey"
                  />
                </div>
              </div>
            </div>

            <p class="description">
              {{ t("ccOnBoarding.basicInformation.question") }}
            </p>
            <p class="remark">
              ({{ t("ccOnBoarding.basicInformation.questionRemark") }})
            </p>
            <div class="agree">
              <section class="radioClass">
                <RadioButton
                  v-for="option in hrcQuestionnaireEnum"
                  :key="option.value"
                  :label="option.label"
                  :values="option.value"
                  class="radioHorizontal"
                  field="question"
                  id="q2"
                  :selected-value="prop.basicInformation.question1"
                  :label-class="'radioLabel'"
                  @selected="question1Selection"
                  :class="{ 'display-flex': true }"
                />
              </section>
            </div>
            <pre class="help" v-if="!errorMessage">
                  {{ errorMessage }}</pre
            >
            <pre class="help" v-else-if="error && errorMessage">{{
              errorMessage
            }}</pre>
            <pre class="help" v-else>&nbsp</pre>

            <div v-if="prop.basicInformation.question1 == 'Yes'">
              <p class="smallTitle">
                {{ t("ccOnBoarding.basicInformation.repaymentTitle") }}
              </p>

              <div :class="[deviceType, 'inputText']">
                <NewCurrencyInput
                  class="inputcomponent"
                  v-model.number="prop.basicInformation.repayment"
                  field="repayment"
                  :required="false"
                  :max-length="15"
                  :placeholder="t('ccOnBoarding.basicInformation.repayment')"
                  :autocomplete="'new-password'"
                  :inputmode="'numeric'"
                  onkeypress="
                    return event.charCode >= 48 && event.charCode <= 57;
                  "
                  @keydown.enter.prevent="handleEnterKey"
                />
              </div>
            </div>
            <div v-if="deviceType != 'Mobile'" :class="[deviceType, 'agree2']">
              <CheckBoxValid
                id="agree"
                class="checkbox"
                :required="false"
                field="ampConsent"
                @selected="handleCCConsent"
                :selected-value="prop.basicInformation.consent"
                :nopre="true"
              >
                <template v-slot:label>
                  <p class="checkbox-label2">
                    {{ t("ccOnBoarding.basicInformation.agree") }}
                    <a
                      class="termOfService"
                      @click="openDeclarationAgreementModal"
                    >
                      {{ t("ccOnBoarding.basicInformation.policy") }}</a
                    >, {{ t("ccOnBoarding.basicInformation.credit") }}
                    <a
                      :href="cc_tnc_path"
                      target="_blank"
                      class="termOfService"
                    >
                      {{ t("ccOnBoarding.basicInformation.terms") }}</a
                    >
                    {{ t("ccOnBoarding.basicInformation.and") }}
                    <a
                      :href="cc_psd_path"
                      target="_blank"
                      class="termOfService"
                    >
                      {{ t("ccOnBoarding.basicInformation.disclosure") }}</a
                    >.
                  </p>
                </template>
              </CheckBoxValid>
            </div>
            <div
              v-if="deviceType != 'Mobile'"
              :class="[deviceType, 'virtualCC']"
            >
              <VirutalCCBar></VirutalCCBar>
            </div>
          </div>
        </div>
      </div>
      <div v-if="deviceType == 'Mobile'" :class="[deviceType, 'inner-last']">
        <div :class="[deviceType, 'agree2']">
          <CheckBoxValid
            id="agree"
            class="checkbox"
            :required="false"
            field="ampConsent2"
            @selected="handleCCConsent"
            :selected-value="prop.basicInformation.consent"
            :disabled="prop.status === 'false'"
            :nopre="true"
          >
            <template v-slot:label>
              <p class="checkbox-label2">
                {{ t("ccOnBoarding.basicInformation.agree") }}
                <a class="termOfService" @click="openDeclarationAgreementModal">
                  {{ t("ccOnBoarding.basicInformation.policy") }}</a
                >, {{ t("ccOnBoarding.basicInformation.credit") }}
                <a :href="cc_tnc_path" target="_blank" class="termOfService">
                  {{ t("ccOnBoarding.basicInformation.terms") }}</a
                >
                {{ t("ccOnBoarding.basicInformation.and") }}
                <a :href="cc_psd_path" target="_blank" class="termOfService">
                  {{ t("ccOnBoarding.basicInformation.disclosure") }}</a
                >.
              </p>
            </template>
          </CheckBoxValid>
        </div>
        <div v-if="deviceType == 'Mobile'" :class="[deviceType, 'virtualCC']">
          <VirutalCCBar></VirutalCCBar>
        </div>
      </div>

      <div :class="[deviceType, 'buttoncontainer']">
        <!-- <button
          v-if="prop.type == 'BIO'"
          :class="[deviceType, 'left-button']"
          type="button"
          @click="handleBack"
        >
          {{ t("ccOnBoarding.back") }}
        </button> -->
        <div
          :class="[deviceType, 'left-button']"
          style="visibility: hidden"
        ></div>
        <button :class="[deviceType, 'right-button']" :disabled="isBtnDisabled">
          {{ t("ccOnBoarding.next") }}
        </button>
      </div>
    </Form>
  </div>
  <div v-if="prop.overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
  <PopupMessage
    name="pdfName"
    :type="pdfType"
    :header="headerName"
    v-if="isTNCModalOpen"
    @close-modal="closeTNCModal"
    :popup="true"
  >
  </PopupMessage>
</template>

<script setup lang="ts">
import {
  ref,
  computed,
  watch,
  watchEffect,
  onBeforeMount,
  type PropType,
  onMounted,
  type Ref,
} from "vue";
import Headers from "./components/Headers.vue";
import PogressBarStep from "./components/ProgressBarStep.vue";
import DropDown from "./components/NewDropDownComponent.vue";
import InputText from "./components/NewInputTextComponent.vue";
import NewCurrencyInput from "./components/NewCurrencyInput.vue";
import DatePicker from "./components/DatePickerComponent.vue";
import i18n from "@/plugin/i18n";
import { Form } from "vee-validate";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import type { BasicInformation, Card } from "@/interface/FormCC";
import RadioButton from "./components/NewRadioButtonComponent.vue";
import hrcQuestionnaireEnum from "@/enum/HRCQuestionnaireEnum";
import { deviceDetect } from "mobile-device-detect";
import CheckBoxValid from "./components/NewCheckBox.vue";
import Constants from "@/constants/constants";
import PopupMessage from "./components/PopupMessage.vue";
import type FormCCOtp from "@/interface/FormCCOtp";
import VirutalCCBar from "./components/VirutalCCBar.vue";

const deviceType = ref("");

// const cc_tnc = Constants.AEON_CC_TNC;
// const cc_psd = Constants.AEON_CC_PSD;

const { t } = i18n.global;

interface CardType {
  code: string;
  value: string;
  minAge: string;
  maxAge: string;
  nationality: string;
  minSalary: string;
}

const prop = defineProps({
  basicInformation: {
    type: Object as PropType<BasicInformation>,
    required: true,
  },
  otp: {
    type: Object as PropType<FormCCOtp>,
    required: true,
  },
  status: {
    type: String,
  },
  newForm: {
    type: Boolean,
    required: true,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  cardName: {
    type: String,
    required: true,
  },
  cardMinSalary: {
    type: String,
    required: true,
  },
  cardId: {
    type: String,
    required: true,
  },
  ekyc: {
    type: String,
    required: true,
  },
  countDown: {
    type: String,
  },
  selectedCard: {
    type: Object as PropType<Card>,
    required: true,
  },
  type: {
    type: String,
  },
  webFormRequestId: {
    type: String,
  },
  isAutoPopulate: {
    type: Boolean,
    default: false,
  },
  autoPopulateDisabledField: {
    type: Object,
    required: true,
  },
  populatedIdInfo: {
    type: Object,
    required: true,
  },
  pfExpired: {
    type: Boolean,
    default: false,
  },
  verification: {
    type: String,
  },
  acc: {
    type: String,
  },
});

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

const dateParts = ref(prop.basicInformation.dob.split("/"));
const year = ref("");
const month = ref("");
const day = ref("");

if (prop.basicInformation.dob != "") {
  year.value = dateParts.value[2].substring(2, 4);
  month.value = dateParts.value[1];
  day.value = dateParts.value[0];
}

interface IdType {
  code: string;
  value: string;
}

const isClear = ref("false");
const idNoInput = ref("");
const error = ref(true);
const errorMessage = ref("");
const pdfName = ref("");
const pdfType = ref("");
const headerName = ref("");
const bioDisabledField = ref(false);
const finPlusAndMosDisabledField = ref(false);

const cc_tnc_path = ref("");
const cc_psd_path = ref("");

//List
let titleList = ref([]);
let idTypeList = ref<IdType[]>([]);
let nationalityList = ref([]);
let mobileCountryCodeList = ref([]);
let professionList = ref([]);
let jcklClubStatusList = ref([]);
let isTNCModalOpen = ref(false);

const cardTypeList: Ref<CardType[]> = ref([]);

const cardObject = ref<CardType[]>([]);

onBeforeMount(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });

  MasterService.getMasterData()
    .then((res) => {
      titleList.value = res.data.titleType;
      idTypeList.value = res.data.idType;
      mobileCountryCodeList.value = res.data.mobileNoCountryCode;
      professionList.value = res.data.professionalType;
      jcklClubStatusList.value = res.data.jcklClubStatus;

      if (prop.verification == "true") {
        idTypeList.value = idTypeList.value.filter(
          (id) => id.value !== "Passport",
        );
      }
    })
    .catch((e) => {});

  MasterService.getNationalityData()
    .then((res) => {
      nationalityList.value = res.data.nationalityType;
    })
    .catch((e) => {});

  MasterService.getTNCPath("en")
    .then((res) => {
      cc_tnc_path.value = res.data.tncDoc;
      cc_psd_path.value = res.data.pdsDoc;
    })
    .catch((e) => {});

  MasterService.cardType()
    .then((res) => {
      cardTypeList.value = res.data.responseModel.cardTypeList;
      cardObject.value = cardTypeList.value.filter(
        (cardType) => cardType.code === prop.cardId,
      );
    })
    .catch((e) => {});
  if (prop.basicInformation.idType == "") {
    prop.basicInformation.idType = "0";
  }

  if (prop.verification == "true") bioDisabledField.value = true;

  if (prop.type == "FINPLUS" || prop.type == "CR_SL")
    finPlusAndMosDisabledField.value = true;

  // first time in basic info page
  if (!prop.autoPopulateDisabledField.basicInformationSubmit) {
    if (
      prop.isAutoPopulate &&
      prop.basicInformation.idType == "0" &&
      prop.basicInformation.idNo
    )
      prop.autoPopulateDisabledField.icNo = true;
    if (
      prop.isAutoPopulate &&
      prop.basicInformation.idType == "1" &&
      prop.basicInformation.idNo
    )
      prop.autoPopulateDisabledField.passport = true;
    if (prop.isAutoPopulate && prop.basicInformation.militaryNo)
      prop.autoPopulateDisabledField.militaryNo = true;
    if (
      prop.isAutoPopulate &&
      prop.basicInformation.idType == "1" &&
      prop.basicInformation.nationality
    )
      prop.autoPopulateDisabledField.nationality = true;
  }

  if (
    prop.isAutoPopulate &&
    !prop.autoPopulateDisabledField.basicInformationSubmit
  ) {
    prop.populatedIdInfo.icNumber =
      prop.basicInformation.idType == "0" ? prop.basicInformation.idNo : "";
    prop.populatedIdInfo.passport =
      prop.basicInformation.idType == "1" ? prop.basicInformation.idNo : "";
    prop.populatedIdInfo.oldIc = prop.basicInformation.oldIc;
    prop.populatedIdInfo.militaryNo = prop.basicInformation.militaryNo;
  }
});

const defaultNationality = computed(() => {
  return prop.basicInformation.idType === "0" ||
    prop.basicInformation.idType === "2" ||
    prop.basicInformation.idType === "3"
    ? "MY"
    : prop.basicInformation.nationality;
});
watchEffect(() => {
  if (defaultNationality.value === "MY") {
    prop.basicInformation.nationality = defaultNationality.value;
  } else if (prop.basicInformation.idType != "0") {
    prop.basicInformation.nationality = prop.basicInformation.nationality;
  }
  //   else if (defaultNationality.value != tempcheck.value) {
  //   nationality.value = "";
  // }
});

const computedDob = computed(() => {
  if (
    prop.basicInformation.idNo.length == 12 &&
    prop.basicInformation.idType != "1"
  ) {
    return prop.basicInformation.idNo.substring(0, 6);
  }
  return year.value + month.value + day.value;
});

const computedDobTwo = computed(() => {
  if (
    prop.basicInformation.idNo.length == 12 &&
    prop.basicInformation.idType != "1"
  ) {
    return prop.basicInformation.idNo.substring(0, 2);
  }
  return "";
});

const schema = computed(() => {
  const minAge = ref("");
  const maxAge = ref("");
  const minSalary = ref("");
  if (prop.basicInformation.idType == "1") {
    const filteredCard = cardObject.value.find(
      (cardType) => cardType.nationality === "NON-MY",
    );
    if (filteredCard) {
      minAge.value = filteredCard.minAge;
      maxAge.value = filteredCard.maxAge;
      minSalary.value = filteredCard.minSalary;
    }
  } else {
    const filteredCard = cardObject.value.find(
      (cardType) => cardType.nationality === "MY",
    );
    if (filteredCard) {
      minAge.value = filteredCard.minAge;
      maxAge.value = filteredCard.maxAge;
      minSalary.value = filteredCard.minSalary;
    }
  }
  const idNoIcFormat = prop.basicInformation.idType != "1";
  const military =
    prop.basicInformation.idType == "2" || prop.basicInformation.idType == "3";
  const idNoPassportFormat = prop.basicInformation.idType == "1";
  const othersProfession = prop.basicInformation.profession == "90";
  const repayment = prop.basicInformation.question1 == "Yes";
  const countryCode = prop.basicInformation.countryCode == "60";
  const homeCountryCode = prop.basicInformation.homeCountryCode == "60";
  const nationalityMY =
    prop.basicInformation.nationality == "MY" &&
    prop.basicInformation.idType == "1";
  const jcklCard = prop.selectedCard.cardId == "JC" || prop.cardId == "JC";
  return {
    fullName:
      prop.pfExpired || prop.type == "CR_SL"
        ? "required"
        : "required|nameFormat",
    idType: "required",
    idNo:
      idNoIcFormat || military
        ? "required|minLengthNumber:12|icNo|numberFormat"
        : idNoPassportFormat
          ? "required|minLengthNumber:8|maxLengthNumber:12"
          : "",
    oldIc:
      idNoIcFormat &&
      computedDobTwo.value <= "78" &&
      Number(computedDobTwo.value) >= currentYear &&
      computedDobTwo.value != ""
        ? "minLengthNumber:8|maxLengthNumber:8"
        : "",
    militaryNo: military ? "required|maxLengthNumber:21" : "",
    nationality: nationalityMY ? "invalidNationality|required" : "required",
    dob: `maxAge:${65}|minAge:${21}`,
    jcklMembershipNo: jcklCard
      ? "required|minLengthNumber:6|maxLengthNumber:50"
      : "",
    jcklClubStatus: jcklCard ? "required" : "",
    email: "required|email",
    // mobileNo: countryCode
    //   ? "requiredNumber|minLengthNumber:7|maxLengthNumber:10|numberFormat|mobileMY"
    //   : "requiredNumber|minLengthNumber:7|maxLengthNumber:10|numberFormat|mobileSG",
    mobileNo: countryCode
      ? "requiredNumber|minLengthNumber:9|maxLengthNumber:10|numberFormat"
      : "requiredNumber|minLengthNumber:8|maxLengthNumber:9|numberFormat",
    // homeNo: homeCountryCode
    //   ? "minLengthNumber:7|maxLengthNumber:10|numberFormat|mobileMY"
    //   : "minLengthNumber:7|maxLengthNumber:10|numberFormat|mobileSG",
    homeNo: homeCountryCode
      ? "minLengthNumber:7|maxLengthNumber:10|numberFormat"
      : "minLengthNumber:7|maxLengthNumber:10|numberFormat",
    // grossSalary: `requiredNumber|numberFormat|minSalary:${minSalary.value}`,
    grossSalary: `requiredNumber|numberFormat`,
    netSalary: `requiredNumber|numberFormat|maxValue:${
      prop.basicInformation.grossSalary
    },${t("ccOnBoarding.basicInformation.grossMonthlySalaryNoMyr")}`,
    profession: "required",
    others: othersProfession ? "required" : "",
    repayment: repayment ? "requiredNumber" : "",
  };
});

const computedMaxLength = computed(() =>
  prop.basicInformation.idType === "0" ? 12 : 12,
);

const computedPattern = computed(() =>
  prop.basicInformation.idType === "0" ||
  prop.basicInformation.idType === "2" ||
  prop.basicInformation.idType === "3"
    ? /^\d+$/
    : /^[A-Za-z]\d{8}$/,
);

const question1Selection = (option: string) => {
  prop.basicInformation.question1 = option;
  error.value = false;
};

const handleNameKeyDown = (event: KeyboardEvent) => {
  // const isSymbol = /[^\sa-zA-Z_]/.test(event.key);
  const isSymbol = /^[a-zA-Z@#()_:\/.,'\-\s]+$/.test(event.key);
  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  if (
    !isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const handleJCKLMembershipKeyDown = (event: KeyboardEvent) => {
  // ✅ Allow only A–Z, a–z, 0–9, and dash (-)
  const isAllowedChar = /^[a-zA-Z0-9-]$/.test(event.key);

  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === "Tab";
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  if (
    !isAllowedChar &&
    !isBackspace &&
    !isDeleteKey &&
    !isTabKey &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey)
  ) {
    event.preventDefault();
  }
};

const handleKeyDown = (event: KeyboardEvent) => {
  const isDigit = /^[0-9]$/.test(event.key);
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";

  const isSymbol = /[^\w\d_]/.test(event.key); // true for symbol input

  if (
    (prop.basicInformation.idType === "0" ||
      prop.basicInformation.idType === "1" ||
      prop.basicInformation.idType === "2" ||
      prop.basicInformation.idType === "3") &&
    isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const currentYear = parseInt(
  new Date().getFullYear().toString().substring(2, 4),
  10,
);

const isBtnDisabled = computed(() => {
  const minSalary = ref();
  if (prop.basicInformation.idType == "1") {
    const filteredCard = cardObject.value.find(
      (cardType) => cardType.nationality === "NON-MY",
    );
    if (filteredCard) {
      minSalary.value = filteredCard.minSalary;
    }
  } else {
    const filteredCard = cardObject.value.find(
      (cardType) => cardType.nationality === "MY",
    );
    if (filteredCard) {
      minSalary.value = filteredCard.minSalary;
    }
  }
  return (
    prop.basicInformation.name.length == 0 ||
    prop.basicInformation.idType.length == 0 ||
    prop.basicInformation.idNo.length == 0 ||
    ((prop.basicInformation.idType == "2" ||
      prop.basicInformation.idType == "3") &&
      prop.basicInformation.militaryNo.length == 0) ||
    prop.basicInformation.nationality.length == 0 ||
    prop.basicInformation.dob.length == 0 ||
    ((prop.selectedCard.cardId == "JC" || prop.cardId == "JC") &&
      (prop.basicInformation.jcklMembershipNo.length == 0 ||
        prop.basicInformation.jcklClubStatus.length == 0)) ||
    prop.basicInformation.email.length == 0 ||
    prop.basicInformation.countryCode.length == 0 ||
    prop.basicInformation.mobileNo.length == 0 ||
    prop.basicInformation.grossSalary == 0 ||
    prop.basicInformation.netSalary == 0 ||
    prop.basicInformation.profession.length == 0 ||
    (prop.basicInformation.profession == "90" &&
      prop.basicInformation.others.length == 0) ||
    prop.basicInformation.question1.length == 0 ||
    (prop.basicInformation.question1 == "Yes" &&
      prop.basicInformation.repayment == 0) ||
    prop.basicInformation.consent !== "true"
    // ||
    // (prop.basicInformation.grossSalary != 0 &&
    //   prop.basicInformation.grossSalary < minSalary.value)
  );
});

const handleCCConsent = (value: string) => {
  if (value) prop.basicInformation.consent = value;
  else prop.basicInformation.consent = "";
};

const openDeclarationAgreementModal = () => {
  isTNCModalOpen.value = true;

  pdfType.value = "declaration";
  headerName.value = "usagePolicy";
};

const closeTNCModal = () => {
  isTNCModalOpen.value = false;
};

const cardList = ref<Card[]>([]);

const onInvalidSubmit = () => {};
const emit = defineEmits([
  "nextStep",
  "jumpStep",
  "submit",
  "overlay",
  "closeOverlay",
]);
const onSubmit = () => {
  emit("overlay");
  if (!prop.autoPopulateDisabledField.basicInformationSubmit)
    prop.autoPopulateDisabledField.basicInformationSubmit = true;
  const requestModel = {
    nationality: prop.basicInformation.nationality,
    applicationChannel: prop.acc,
    type: prop.type,
    // grossSalary: prop.basicInformation.grossSalary,
  };
  if (prop.cardId != "" && prop.cardId != "NA") {
    // console.log(prop.cardId);
    MasterService.cardValidate(requestModel)
      .then((res) => {
        for (let i = 0; i < res.data.responseModel.cardList.length; i++) {
          cardList.value.push({
            image: res.data.responseModel.cardList[i].cardImage,
            cardName: res.data.responseModel.cardList[i].cardDesc,
            cardInfo: res.data.responseModel.cardList[i].cardDesc2,
            cardId: res.data.responseModel.cardList[i].cardCode,
            selected: false,
            nationality: res.data.responseModel.cardList[i].nationality,
            minAge: res.data.responseModel.cardList[i].minAge,
            minSalary: res.data.responseModel.cardList[i].minSalary,
            defaultCard: res.data.responseModel.cardList[i].defaultCard,
          });
        }
        let isCardId = "";
        if (prop.selectedCard.cardId != "") {
          isCardId = prop.selectedCard.cardId;
        } else isCardId = prop.cardId;
        let selectedNationality =
          prop.basicInformation.nationality == "MY" ? "MY" : "NON-MY";
        const isCard = cardList.value.find(
          (cardType) =>
            cardType.cardId === isCardId &&
            cardType.nationality === selectedNationality,
        );

        if (isCard) {
          prop.selectedCard.cardId = isCard.cardId;
          prop.selectedCard.cardInfo = isCard.cardInfo;
          prop.selectedCard.cardName = isCard.cardName;
          prop.selectedCard.image = isCard.image;
          prop.selectedCard.minAge = isCard.minAge;
          prop.selectedCard.minSalary = isCard.minSalary;
          prop.selectedCard.nationality = isCard.nationality;
          if (prop.basicInformation.grossSalary < prop.selectedCard.minSalary) {
            const otherCard = cardList.value.filter(
              (cardType) =>
                cardType.minSalary <= prop.basicInformation.grossSalary &&
                cardType.nationality === selectedNationality,
            );
            emit("closeOverlay");
            if (otherCard.length > 0)
              emit("jumpStep", 14, "cardApplicationUnsucessful", 4);
            else emit("jumpStep", 14, "cardApplicationNotQualify", 4);
          } else emit("submit");
        }
      })
      .catch((e) => {});
  } else {
    MasterService.cardValidate(requestModel)
      .then((res) => {
        for (let i = 0; i < res.data.responseModel.cardList.length; i++) {
          cardList.value.push({
            image: res.data.responseModel.cardList[i].cardImage,
            cardName: res.data.responseModel.cardList[i].cardDesc,
            cardInfo: res.data.responseModel.cardList[i].cardDesc2,
            cardId: res.data.responseModel.cardList[i].cardCode,
            selected: false,
            nationality: res.data.responseModel.cardList[i].nationality,
            minAge: res.data.responseModel.cardList[i].minAge,
            minSalary: res.data.responseModel.cardList[i].minSalary,
            defaultCard: res.data.responseModel.cardList[i].defaultCard,
          });
        }
        const otherCard = cardList.value.filter(
          (cardType) => cardType.minSalary <= prop.basicInformation.grossSalary,
        );

        if (otherCard.length > 0) emit("submit");
        else {
          emit("closeOverlay");
          emit("jumpStep", 14, "cardApplicationNotQualify", 4);
        }
      })
      .catch((e) => {});
  }
};

watch(
  () => prop.basicInformation.idType,
  (newValue, oldValue) => {
    if (prop.isAutoPopulate && newValue) {
      if (oldValue == "0") {
        prop.populatedIdInfo.icNumber = prop.basicInformation.idNo;
        prop.populatedIdInfo.oldIc = prop.basicInformation.oldIc;
      } else if (oldValue == "1") {
        prop.populatedIdInfo.passport = prop.basicInformation.idNo;
      } else if (oldValue == "2" || oldValue == "3") {
        prop.populatedIdInfo.icNumber = prop.basicInformation.idNo;
        prop.populatedIdInfo.militaryNo = prop.basicInformation.militaryNo;
        prop.populatedIdInfo.oldIc = prop.basicInformation.oldIc;
      }

      if (newValue == "0") {
        prop.basicInformation.idNo = prop.populatedIdInfo.icNumber;
        prop.basicInformation.oldIc = prop.populatedIdInfo.oldIc;
      } else if (newValue == "1") {
        prop.basicInformation.idNo = prop.populatedIdInfo.passport;
      } else if (newValue == "2" || newValue == "3") {
        prop.basicInformation.idNo = prop.populatedIdInfo.icNumber;
        prop.basicInformation.oldIc = prop.populatedIdInfo.oldIc;
        prop.basicInformation.militaryNo = prop.populatedIdInfo.militaryNo;
      }
    }
  },
);

watch(
  () => prop.basicInformation.idType,
  (newValue, oldValue) => {
    if (newValue && !prop.isAutoPopulate) {
      // isClear.value = oldValue === "0" ? "1" : "0";
      prop.basicInformation.oldIc = "";
    }
  },
);

let previousValue: string | null = null;
watch(
  () => prop.basicInformation.idType,
  (newValue) => {
    if (newValue && !prop.isAutoPopulate) {
      // isClear.value = previousValue === "0" ? "1" : "0";
      // previousValue = isClear.value;
      prop.basicInformation.militaryNo = "";
    }
    if (newValue == "1" && prop.basicInformation.nationality == "MY") {
      prop.basicInformation.nationality = "";
    }
  },
);
watch(
  () => prop.basicInformation.question1,
  (newValue) => {
    if (newValue) {
      prop.basicInformation.repayment = 0;
    }
  },
);

watch(
  () => prop.basicInformation.profession,
  (newValue) => {
    if (newValue) {
      prop.basicInformation.others = "";
    }
  },
);

watch(
  () => prop.basicInformation.countryCode,
  (newValue) => {
    if (newValue) {
      prop.basicInformation.mobileNo = "";
    }
  },
);

const handleBack = () => {
  emit("jumpStep", 16, "", 4);
};

const handleEnterKey = () => {};
</script>

<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

.container,
.container2 {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.container3,
.container4 {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
}

.full {
  width: 100%;
}

.flex_dropdown {
  display: flex;
  width: 30%;
  box-sizing: border-box;
  position: relative;
  display: inline-block;
}

.flex_third {
  width: 30%;
}

.flex_inputText {
  width: 70%;
}

.flex_half {
  width: 50%;
}

.separator {
  margin-bottom: 37px;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.dropdown {
  margin-bottom: 14px;
}

.inputText {
  margin-bottom: 14px;
  width: 100%;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;
  flex: 0 0 25%;
}

.left-button {
  flex: 0 0 15%;
}

.agree {
  display: flex;
  align-items: flex-start;
}

.radioClass {
  display: flex;
  align-items: flex-end;
}

.radioHorizontal {
  margin-right: 24px !important;
  color: rgba(0, 0, 0, 0.38);
  margin-bottom: 5px;
}

.description {
  color: #212121;
  font: 500 16px/130% "Outfit";
  margin-bottom: 2px;
  text-align: left;
  position: relative;
  align-self: stretch;
}

.remark {
  color: rgba(0, 0, 0, 0.38);
  font: 500 12px/130% "Outfit";
  margin-bottom: 10px;
  text-align: left;
  position: relative;
  align-self: stretch;
}

.smallTitle {
  margin-bottom: 30px;
  color: #9e9e9e;
  font: 500 14px/130% "Outfit";
  text-align: left;
  position: relative;
  align-self: stretch;
}

.help {
  color: red;
  margin-bottom: 0px;
  font:
    400 16px/130% "Outfit",
    sans-serif;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.agree2:is(.Desktop, .Tablet) {
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
  border-bottom: 1px solid #e4e4e4;
}

.virtualCC:is(.Desktop, .Tablet) {
  border-bottom: 1px solid #e4e4e4;
}

.virtualCC:is(.Mobile) {
  padding: 8px 0px;
  border-bottom: none;
  border-top: 1px solid #e4e4e4;
}

.checkbox {
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  font-family: Outfit;
  font-weight: 500;
  line-height: 18.2px;
  word-wrap: break-word;
}

.checkbox-label2 {
  position: relative;
  align-items: center;
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  font-family: "Outfit";
  font-size: 14px;
  font-weight: 500;
  line-height: 130%;
  margin-left: 8px;
  margin-bottom: 0px;
}

.termOfService {
  background: none !important;
  border: none;
  color: #ac2887;
  font-size: 14px;
  font-family: Outfit;
  font-weight: 500;
  line-height: 18.2px;
  word-wrap: break-word;
  cursor: pointer;
  text-decoration: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

.cardName {
  color: rgba(0, 0, 0, 0.38);
  font: 500 16px/130% "Outfit";
  margin-bottom: 10px;
  margin-top: 5px;
  text-align: left;
  position: relative;
  align-self: stretch;
}

.cardName:is(.Mobile) {
  padding-left: 20px;
}

@media (max-width: 700px) {
  .container:is(.Desktop, .Tablet),
  .container2:is(.Desktop, .Tablet),
  .container3:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 14px;
  }

  .container4:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 0;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .flex_half:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .flex_third:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
    /* display: none; */
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 0;
  }

  /* .virtualCC:is(.Desktop, .Tablet) {
    padding: 10px 0px;
  } */

  /* .dates:is(.Desktop, .Tablet) {
    margin-bottom: 10px;
  } */
}

/* Mobile */
.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.inner-last:is(.Mobile) {
  border-top: 1px solid #e4e4e4;
  padding: 0px 20px;
  border-bottom: 1px solid #e4e4e4;
}

.container:is(.Mobile),
.container2:is(.Mobile) {
  flex-direction: column;
  gap: 14px;
}

.container3:is(.Mobile) {
  max-width: none !important;
}

.container4:is(.Mobile) {
  flex-direction: column;
  gap: 0;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}

.flex_inputText:is(.Mobile) {
  width: 100%;
}
.flex_half:is(.Mobile) {
  width: 100%;
}

.flex_third:is(.Mobile) {
  width: 30%;
}

.buttoncontainer:is(.Mobile) {
  /* flex-wrap: wrap;
  display: flex;
  justify-content: space-between; */
  align-items: center;
  padding: 24px 20px 20px 20px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
  /* display: none; */
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:is(.Mobile):disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 68%;
}

.separator:is(.Mobile) {
  margin-bottom: 0;
}

.content:is(.Mobile) {
  padding: 0;
}

.agree2:is(.Mobile) {
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
}

/* .dates:is(.Mobile) {
  margin-bottom: 10px;
} */

.disclaimerContainer1 {
  width: -webkit-fill-available;
  padding: 10px 15px;
  background: #eaf7fe;
  border-radius: 8px;
  overflow: hidden;
  align-items: flex-start;
  gap: 8px;
  display: inline-flex;
  border-left: 6px solid rgb(122, 196, 236);
  margin-bottom: 15px;
}

.disclaimerSubContainer1 {
  flex: 1 1 0;
  color: #757575;
  font-size: 14px;
  font-family: Outfit;
  font-weight: 400;
  line-height: 20.8px;
  word-wrap: break-word;
}
</style>
